tllib = {
  sleep: ms => new Promise(resolve => setTimeout(resolve, ms)),

  isVisible: element => {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  },

  getBetween: (startStr, endStr, str) => str.split(startStr)[1].split(endStr)[0],

  styles: {
    colors: {
      tlorange: '#204623',
      tlbrown: '#534536',
    },
    font: {
      primary: '"Oswald", arial',
      secondary: '"Work Sans", "HelveticaNeue", "Helvetica Neue", sans-serif'
    }
  },

};
